// Header detection for the CSVs clients upload to back a file filter.
//
// The API resolves a filter's values from the column named after the filter
// attribute, so the first row only counts as a header when one of its cells
// names that attribute. Everything is normalized first, because spreadsheets
// and text editors export headers with a BOM, wrapping quotes, padding or a
// different case — comparing the raw cell rejects perfectly good files.

const DELIMITERS = [',', '\t', ';', '|']

// a UTF-8 BOM decoded as text, and the same three bytes read as latin-1
const BOM = /^(\ufeff|\u00ef\u00bb\u00bf)/

export const normalizeCell = (cell = '') =>
  cell
    .replace(BOM, '')
    .trim()
    .replace(/^["']|["']$/g, '')
    .trim()
    .toLowerCase()

export const splitCells = (line = '') => {
  const delimiter = DELIMITERS.find((candidate) => line.includes(candidate)) || ','
  return line.split(delimiter).map(normalizeCell)
}

export const hasHeaderNamed = (contents = '', headerValue = '') => {
  const expected = normalizeCell(headerValue)
  if (!expected) return false
  return splitCells(contents.split(/\r?\n/)[0] || '').includes(expected)
}
